export default __webpack_public_path__ + "static/media/3435 knife block C side.b369c419.png";